import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=22ff1df4&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
import style1 from "./Overview.vue?vue&type=style&index=1&id=22ff1df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff1df4",
  null
  
)

export default component.exports